import React, { useState } from "react";
import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import importedData from "../../data/productCategories.json";
import CategoryCard from "../../components/categoryCard/categoryCard";
import "./landingPage.css";
import "bootstrap/dist/css/bootstrap.min.css";
import useCategoryTree from "../../services/useCategoryTree";
import ICategory from "../../interfaces/ICategory";

export const LandingPage = () => {
  const {tree, error, isLoading} = useCategoryTree();
  window.localStorage.setItem("currentCategoryID","");  
  window.localStorage.setItem("subCurrentCategoryID", "");
  window.localStorage.setItem("thirdCurrentCategoryID", ""); 
  return (
    <Container className="landing-page-body">

      <Container className="landing-page-content-container">
        {tree && tree.children.map((category:ICategory, index:number) => {          
          return <CategoryCard key={index} category={category} />;
        })}
      </Container>
    </Container>
  );
};

// export interface IProduct {
//   DisplayName: string;
//   ID: number;
//   Image: string;
//   SubcategoryCollection: any[];
// }

export default LandingPage;
